export interface VideoInfo {
  link: string;
  preview: string;
  title: string;
}

export interface VideoRow {
  link?: string;
  code?: string;
}

export enum VideoPlatformId {
  YOUTUBE = 'youtube',
  RUTUBE = 'rutube',
  VK = 'vk'
}
